import { icon } from './icons.js';
import { emit, escapeHTML as esc, sortedBookmarks, timeLabel } from '../core/utils.js';

export class Bookmarks extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `<div class="section-heading"><h2>Practice bookmarks <span class="bookmark-count">0</span></h2></div>
      <div class="bookmark-list"></div><div class="bookmark-empty"><div class="empty-symbol">${icon('bookmark')}</div><div><h3>Save the bit you want to get right.</h3><p>Add a bookmark at any moment, then jump straight back.</p></div><kbd>B</kbd></div>
      `;
    this.addEventListener('click', event => {
      const action = event.target.closest('[data-action]'); if (!action) return;
      if (action.dataset.action === 'go') emit(this, 'command', { type: 'go-bookmark-id', id: action.dataset.id });
      if (action.dataset.action === 'edit') emit(this, 'command', {type:'edit-bookmark',id:action.dataset.id});
      if (action.dataset.action === 'delete') emit(this, 'command', { type: 'delete-bookmark', id: action.dataset.id });
    });
  }
  update(project, time, pausedBookmarkID = null) {
    this.project = project;
    const bookmarks = sortedBookmarks(project?.bookmarks || []);
    const signature = JSON.stringify(bookmarks);
    this.querySelector('.bookmark-empty').hidden = !!bookmarks.length;
    this.querySelector('.bookmark-count').textContent = bookmarks.length;
    if (this.signature !== signature) {
      this.signature = signature;
      this.querySelector('.bookmark-list').innerHTML = bookmarks.map(b => `<article class="bookmark-item" data-time="${b.time}"><button class="bookmark-jump" data-action="go" data-id="${esc(b.id)}"><span class="bookmark-number">${b.number}</span><span><strong>${esc(b.name)}</strong><small>${timeLabel(b.time, true)}</small></span>${icon('chevron')}</button><div class="bookmark-actions"><button class="icon-button small" data-action="edit" data-id="${esc(b.id)}" aria-label="Rename ${esc(b.name)}">${icon('edit')}</button><button class="icon-button small" data-action="delete" data-id="${esc(b.id)}" aria-label="Delete ${esc(b.name)}">${icon('trash')}</button></div></article>`).join('');
    }
    const previous = bookmarks.filter(b => b.time <= time + .15).at(-1);
    this.querySelectorAll('.bookmark-item').forEach(item => {
      item.classList.toggle('is-current', Number(item.dataset.time) === previous?.time);
      const button = item.querySelector('.bookmark-jump'), canPlay = button.dataset.id === pausedBookmarkID;
      item.classList.toggle('can-play',canPlay);
      const glyph = button.querySelector(':scope > mt-icon'), name = canPlay ? 'play' : 'chevron';
      if (glyph.getAttribute('name') !== name) glyph.setAttribute('name',name);
      const bookmark = bookmarks.find(b => b.id === button.dataset.id);
      button.setAttribute('aria-label',`${canPlay ? 'Play from' : 'Go to'} bookmark ${bookmark.number}: ${bookmark.name} at ${timeLabel(bookmark.time,true)}`);
    });
  }
}
customElements.define('mt-bookmarks', Bookmarks);
